import { Steps, Divider, Form } from 'antd';
import { useState } from 'react';
import StepWizard from 'react-step-wizard';
import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import Step4 from './Step4';
import Step5 from './Step5';
import Step6 from './Step6';
import Step7 from './Step7';
import Step8 from './Step8';
import StepPreview from './StepPreview';
import { useTranslation } from 'react-i18next';
import ModalDataflow from './ModalDataflow';

import classNames from 'classnames';
import { useDpiaContext } from '../dpia.context';

export default function StepsComponent(props) {
    const {
        setWizard,
        step1,
        step2,
        step3,
        step4,
        setStep1,
        step7,
        step5,
        setStep7,
    } = useDpiaContext();

    const dataflowList = Form.useWatch('dataflowList', props?.dataflowList);
    const [current, setCurrent] = useState(0);
    const [state, updateState] = useState();
    const { t } = useTranslation(['translation', 'dpia']);
    const onChange = (value) => {
        setCurrent(value);
        state?.SW?.goToStep(value + 1);
    };

    const setInstance = (SW) => {
        updateState({
            ...state,
            SW,
        });
        setWizard({
            ...state,
            SW,
        });
    };

    const activeStep = state?.SW?.state?.activeStep;
    const hidden = Boolean(activeStep === 8);

    return (
        <div hidden={!props?.isActive} className="mt-4">
            <div className="bg-white rounded-md mb-4">
                <Steps
                    size="small"
                    type="navigation"
                    current={current}
                    onChange={onChange}
                    className={classNames('site-navigation-steps', {
                        hidden,
                    })}
                    items={[
                        {
                            status: !step1
                                ? 'error'
                                : current === 0
                                ? 'process'
                                : 'wait',
                            title: 'Identification',
                        },
                        {
                            status: !step2
                                ? 'error'
                                : current === 1
                                ? 'process'
                                : 'wait',
                            title: 'Description',
                        },
                        {
                            status: !step3
                                ? 'error'
                                : current === 2
                                ? 'process'
                                : 'wait',
                            title: 'Consultation',
                        },
                        {
                            status: !step4
                                ? 'error'
                                : current === 3
                                ? 'process'
                                : 'wait',
                            title: 'Necessity',
                        },
                        {
                            status: !step5
                                ? 'error'
                                : current === 4
                                ? 'process'
                                : 'wait',
                            title: 'Risk Assessment',
                        },
                        {
                            status: current === 5 ? 'process' : 'wait',
                            title: 'Measures',
                        },
                        {
                            status: !step7
                                ? 'error'
                                : current === 6
                                ? 'process'
                                : 'wait',
                            title: 'Planning',
                        },
                        {
                            status: current === 7 ? 'process' : 'wait',
                            title: 'Monitoring',
                        },
                    ]}
                />
            </div>
            <div className="grid grid-cols-7 gap-4">
                <div
                    className={classNames('bg-white rounded-md p-6', {
                        'col-span-5': !hidden,
                        'col-span-7': hidden,
                    })}
                >
                    <StepWizard
                        isHashEnabled
                        instance={setInstance}
                        onStepChange={({ activeStep }) => {
                            setCurrent(activeStep - 1);
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                        }}
                    >
                        <Step1
                            setStep1={setStep1}
                            form={props?.identification}
                            back={() => props?.goToStep(1)}
                        />
                        <Step2 form={props.description} />
                        <Step3 form={props.consultation} />
                        <Step4 form={props.necessaryProportionality} />
                        <Step5
                            form1={props.identification}
                            form={props.riskAssessment}
                        />
                        <Step6 form={props.measures} />
                        <Step7
                            setStep7={setStep7}
                            form={props?.planning}
                            form6={props?.measures}
                            back={() => props?.goToStep(7)}
                        />
                        <Step8 form={props.monitoring} />
                        <StepPreview
                            values={{
                                identification:
                                    props.identification.getFieldsValue(),
                                description: props.description.getFieldsValue(),
                                consultation:
                                    props.consultation.getFieldsValue(),
                                necessaryProportionality:
                                    props?.necessaryProportionality.getFieldsValue(),
                                riskAssessment:
                                    props.riskAssessment.getFieldsValue(),
                                measures: props.measures.getFieldsValue(),
                                planning: props.planning.getFieldsValue(),
                                monitoring: props.monitoring.getFieldsValue(),
                                dataFlow: props.dataflowList.getFieldsValue(),
                            }}
                        />
                    </StepWizard>
                </div>
                <div
                    className={classNames(
                        'bg-white rounded-md p-6 col-span-2 h-max',
                        {
                            hidden,
                        }
                    )}
                >
                    <div className="text-lg font-semibold">
                        {t('The Data Flow tasks related to this DPIA')}
                        {/* <span className="text-error">*</span> */}
                    </div>
                    <Divider />
                    <ModalDataflow form={props?.dataflowList} />
                    <div className="text-gray-PHX text-base font-semibold">
                        {t('All')} {dataflowList?.length || 0} {t('Lists')}
                    </div>
                </div>
            </div>
        </div>
    );
}
